"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  NftSettingsRegistry: true,
  NftSettingsRegistryNetwork: true,
  NftSettingsRegistryAddress: true,
  BookHelper: true
};
exports.NftSettingsRegistryNetwork = exports.NftSettingsRegistryAddress = exports.NftSettingsRegistry = exports.BookHelper = void 0;
var _BookClient = require("./BookClient");
var _prime = require("./prime");
var _chains = require("@blockwell/chains");
var _ethTypes = require("@blockwell/eth-types");
var _apiminer = require("@blockwell/apiminer");
var _schema = require("./schema");
Object.keys(_schema).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _schema[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _schema[key];
    }
  });
});
var _BookEncoding = require("./BookEncoding");
Object.keys(_BookEncoding).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _BookEncoding[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BookEncoding[key];
    }
  });
});
const NftSettingsRegistry = exports.NftSettingsRegistry = "5.0x823ce3fff79e87168d0c933e56a40eef0cc660d5";
const NftSettingsRegistryNetwork = exports.NftSettingsRegistryNetwork = "5";
const NftSettingsRegistryAddress = exports.NftSettingsRegistryAddress = "0x823ce3fff79e87168d0c933e56a40eef0cc660d5";
class BookHelper {
  constructor(client, cache) {
    this.client = client;
    this.cache = cache;
  }
  async getFoldersAndFiles(network, address) {
    let countResponse = (await this.client.read([{
      network,
      address,
      method: "getFolderCount"
    }]))[0];
    if (typeof countResponse === "string") {
      const count = parseInt(countResponse);
      if (count > 0) {
        let req = [];
        for (let i = 0; i < count; i++) {
          req.push({
            network,
            address,
            method: "getFolderName",
            arg: [i.toString()]
          });
          req.push({
            network,
            address,
            method: "getFolderSizeByIndex",
            arg: [i.toString()]
          });
          req.push({
            network,
            address,
            method: "getEncodingByIndex",
            arg: [i.toString()]
          });
        }
        let res = await this.client.read(req);
        let folders = [];
        for (let i = 0; i < count; i++) {
          const name = (0, _BookClient.bookClientString)(res.shift());
          const size = res.shift();
          const encoding = (0, _BookClient.bookClientString)(res.shift());
          folders.push({
            name,
            encoding,
            size: (0, _BookClient.bookClientInt)(size),
            files: [],
            index: i
          });
        }
        req = [];
        for (let folder of folders) {
          for (let i = 0; i < folder.size; i++) {
            req.push({
              network,
              address,
              method: "getFileName",
              arg: [folder.name, i.toString()]
            });
          }
        }
        res = await this.client.read(req);
        req = [];
        for (let folder of folders) {
          for (let i = 0; i < folder.size; i++) {
            let file = {
              folder: folder.name,
              name: (0, _BookClient.bookClientString)(res.shift())
            };
            req.push({
              network,
              address,
              method: "get",
              arg: [folder.name, file.name]
            });
            folder.files.push(file);
          }
        }
        res = await this.client.read(req);
        for (let folder of folders) {
          for (let file of folder.files) {
            file.content = (0, _BookClient.bookClientString)(res.shift());
          }
        }
        return folders;
      }
    }
    return [];
  }
  async getFiles(network, address, folder) {
    let countResponse = (await this.client.read([{
      network,
      address,
      method: "getFolderSize",
      arg: [folder]
    }]))[0];
    if (typeof countResponse === "string") {
      let count = parseInt(countResponse);
      let fileNameCalls = [];
      for (let i = 0; i < count; i++) {
        fileNameCalls.push({
          network,
          address,
          method: "getFileName",
          arg: [folder, i.toString()]
        });
      }
      let names = (await this.client.read(fileNameCalls)).map((it, index) => {
        if (typeof it === "string") {
          return it;
        }
        throw new Error("Failed to read file name for Book file index " + index);
      });
      let contents = await this.client.read(names.map(it => {
        return {
          network,
          address,
          method: "get",
          arg: [folder, it]
        };
      }));
      return contents.map((it, index) => {
        if (typeof it === "string") {
          return {
            content: it,
            name: names[index],
            index,
            folder
          };
        } else {
          return {
            content: null,
            name: names[index],
            index,
            folder
          };
        }
      });
    }
  }
  async getFilesSet(network, address, files) {
    let res = await this.client.read(files.flatMap(it => {
      return [{
        network,
        address,
        method: "get",
        arg: [it.folder, it.file]
      }, {
        network,
        address,
        method: "getAccessToken",
        arg: [it.folder]
      }];
    }));
    let data = [];
    let i = 0;
    for (let it of files) {
      let content = res[i++];
      let accessToken = res[i++];
      data.push({
        content: typeof content === "string" ? content : null,
        name: it.file,
        folder: it.folder,
        accessToken: typeof accessToken === "string" ? accessToken : null
      });
    }
    return data;
  }
  async getPrimeSettings(network, address, settings, resetCache = false) {
    let cacheKey = `prime-${(0, _apiminer.formatContractId)({
      network,
      address
    })}-${Object.keys(settings).join("-")}`;
    if (resetCache) {
      await this.cache.removeItem(cacheKey);
    }
    return await this.cache.withCache(cacheKey, async () => {
      let res = (await this.client.read([{
        network,
        address,
        method: "getBwQuill",
        arg: [_prime.PRIME_REGISTRY_ADDRESS]
      }]))[0];
      if (typeof res === "string" && res !== _ethTypes.ETH_ADDRESS_ZERO) {
        let bookChain;
        let bookAddress;
        let parsed = (0, _apiminer.parseContractIdFormat)(res);
        if (parsed) {
          bookChain = parsed.chainId;
          bookAddress = parsed.address;
        } else if ((0, _ethTypes.isEthAddress)(res)) {
          let primeContract = await this.client.getContract({
            chainId: network,
            address
          });
          bookChain = (0, _chains.getChain)(primeContract.network).chainId;
          bookAddress = res;
        } else {
          return null;
        }
        return this.readBookSettings(bookChain, bookAddress, settings);
      }
      return null;
    }, true);
  }
  async getNftSettings(chainId, address, settings, resetCache = false) {
    let contractId = (0, _apiminer.formatContractId)({
      chainId,
      address
    });
    let cacheKey = `nft-${contractId}-${Object.keys(settings).join("-")}`;
    if (resetCache) {
      await this.cache.removeItem(cacheKey);
    }
    return await this.cache.withCache(cacheKey, async () => {
      let book = await this.getNftBook(chainId, address);
      if (book) {
        return this.readBookSettings(book.chainId, book.address, settings);
      }
      return null;
    }, true);
  }
  async getNftBook(network, address) {
    let contractId = (0, _apiminer.formatContractId)({
      network,
      address
    });
    let [addressResponse, chainResponse] = await this.client.read([{
      network,
      address,
      method: "bookAddress"
    }, {
      network,
      address,
      method: "bookChainId"
    }]);
    if (typeof addressResponse === "string" && typeof chainResponse === "string" && addressResponse !== _ethTypes.ETH_ADDRESS_ZERO) {
      let chainId = parseInt(chainResponse);
      let address = addressResponse;
      return {
        chainId,
        address
      };
    } else {
      let [file] = await this.getFilesSet(NftSettingsRegistryNetwork, NftSettingsRegistryAddress, [{
        folder: network.toString(),
        file: address.toLowerCase()
      }]);
      if (file.content) {
        let parsed = this.tryParse(file.content);
        if (parsed && parsed.chainId) {
          return {
            chainId: (0, _chains.toChainId)(parsed.chainId),
            address: parsed.address
          };
        }
      }
    }
    return null;
  }
  async readBookSettings(bookChain, bookAddress, settings) {
    let files = await this.getFilesSet(bookChain, bookAddress, Object.values(settings));
    return Object.fromEntries(Object.entries(settings).map(([key, val], index) => {
      let file = files[index];
      let content = this.tryParse(file.content);
      let settings = {
        settings: content,
        accessToken: file.accessToken,
        bookChain,
        bookAddress,
        folder: val.folder,
        file: val.file
      };
      return [key, settings];
    }));
  }
  tryParse(data) {
    if (data) {
      try {
        return JSON.parse(data);
      } catch (err) {
        console.warn("Error parsing Prime settings JSON", err);
      }
    }
    return null;
  }
}
exports.BookHelper = BookHelper;
//# sourceMappingURL=index.js.map